import fetchAPI from '../../fetchAPI';

export const callUpdateCoreKnowledgeBase = async ({
  id,
  locationId,
  question,
  answer
}: {
  id: string;
  locationId: string;
  question: string;
  answer: string;
}): Promise<iResponse<any>> => {
  const response: iResponse<any> = await fetchAPI({
    method: 'PUT',
    route: `knowledge/location/${locationId}/single`,
    data: { id, question, answer },
    isZazu: true
  });

  return response;
};

export default callUpdateCoreKnowledgeBase;
